<template>
  <article class="">
     <cabecera></cabecera>
    <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Contactanos</h2>
    </section>
   
    <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <form-contactenos></form-contactenos>
          </div>
        </div>
      </div>
    </section>
     <div class="banda-azul">
          <div class="texto">
            <h1>Trabajá con nosotros</h1>
           <a href="mailto:empleos@ciamega.com">Enviar CV</a>
          </div>
        </div>

  </article>
</template>

<script>
import FormContactenos from '@/components/contactenos/form-contactenos'
import Cabecera from '@/components/Cabecera'
export default {
  name: 'contactenos',
  components: {
    FormContactenos,
    Cabecera
  }
}
</script>

<style scoped lang="sass">
.descripcion
  min-height: calc(100vh - 420px)
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
.banda-azul
  background: #004d9e
  padding: 50px 0
  width: 100%
  .texto
    display: flex
    align-items: center
    justify-content: center
    h1
      color: #fff
      font-size: 30px
      text-align: center
      font-weight: 400
      @media (max-width: 550px)
        font-size: 20px
    a
      background: #b5babb
      padding: 10px 25px
      color: #004d9e
      text-transform: uppercase
      margin-left: 20px
      font-weight: 700
      &:hover
        background: #fff
        color: #004D9E
</style>



// WEBPACK FOOTER //
// src/components/contactenos/contactenos.vue